import { render, staticRenderFns } from "./GGanttTimeaxis.vue?vue&type=template&id=d18e0788&scoped=true"
import script from "./GGanttTimeaxis.vue?vue&type=script&lang=js"
export * from "./GGanttTimeaxis.vue?vue&type=script&lang=js"
import style0 from "./GGanttTimeaxis.vue?vue&type=style&index=0&id=d18e0788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18e0788",
  null
  
)

export default component.exports